"use client";

import { useRouter } from "next/navigation";
import { CreateHubScreen, type CreateScenario } from "@/miniapp/screens/CreateHubScreen";

/**
 * Reuses the miniapp's CreateHubScreen as a real /create route. Each
 * scenario tile router.pushes to the page that owns that flow — no
 * overlay drawers, since on the web the user expects «полноценные
 * страницы» (modal sheets blocked the bottom-nav, which they didn't
 * like).
 *
 * Single source of truth for routing — both this page and MobileHome's
 * tiles use the same map so the destinations stay in sync.
 */
const SCENARIO_HREFS: Record<CreateScenario, string> = {
    image: "/image-generation",
    video: "/video-generation",
    photoshoot: "/apps/ai-photo-studio",
    audio: "/?openMusic=1",
    animate: "/video-generation",
    tools: "/apps/remove-background",
    templates: "/prompt-library",
    upscale: "/apps/upscale",
    tryon: "/apps/virtual-try-on",
    headshot: "/apps/professional-headshot",
    babydance: "/apps/baby-dance",
    motion: "/apps/kling-motion",
};

export default function CreatePage() {
    const router = useRouter();
    return (
        <CreateHubScreen
            onSelectScenario={(scenario) => {
                const href = SCENARIO_HREFS[scenario];
                if (href) router.push(href);
            }}
        />
    );
}
